module.exports = __webpack_public_path__ + "img/logo.7670362.svg?v=1791296779994";